export enum Regroup {
  None = 'NONE',
  Occasional = 'OCCASIONAL',
  Frequent = 'FREQUENT',
  StayTogether = 'STAY_TOGETHER',
} 